// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconFooterTwitterInactive: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="currentColor">
            <g fill="none" fillRule="evenodd">
                <rect width="39" height="39" x=".5" y=".5" fill="#000" stroke="#333" />
                <path
                    fill="currentColor"
                    fillRule="nonzero"
                    d="M26.3553128,17.2398313 C26.3654695,17.3820121 26.3654695,17.5242235 26.3654695,17.6664053 C26.3654695,22.0031039 23.0660005,27 17.0355315,27 C15.1776567,27 13.4517813,26.4616955 12,25.5273608 C12.2639689,25.5578102 12.5177503,25.5679708 12.7918754,25.5679708 C14.3248444,25.5679708 15.7360315,25.050018 16.8629379,24.1664215 C15.4213128,24.1359406 14.2131877,23.1914148 13.7969375,21.8914049 C14,21.9218543 14.2030315,21.9421746 14.4162502,21.9421746 C14.7106566,21.9421746 15.0050945,21.901534 15.2791882,21.8304746 C13.7766566,21.5257611 12.6497192,20.2054629 12.6497192,18.6109316 L12.6497192,18.5703221 C13.0862508,18.8140738 13.5939069,18.9664148 14.131938,18.986704 C13.2486877,18.3976298 12.6700315,17.3921727 12.6700315,16.2546649 C12.6700315,15.645301 12.832438,15.0867067 13.1167192,14.5992033 C14.730938,16.5898268 17.1573443,17.8898052 19.8781257,18.0320176 C19.8273759,17.7882659 19.7969069,17.5343851 19.7969069,17.2804728 C19.7969069,15.4726392 21.2588449,14 23.0760942,14 C24.0202508,14 24.8730321,14.3960922 25.4720311,15.035937 C26.2131248,14.8937562 26.9237809,14.6195236 27.5532498,14.2437517 C27.3095622,15.0054876 26.7918124,15.6453324 26.1116252,16.0515538 C26.7715316,15.9804943 27.4111257,15.7976415 27.9999375,15.5437606 C27.5533128,16.1937346 26.9949059,16.7726177 26.3553128,17.2398322 L26.3553128,17.2398313 Z"
                />
            </g>
        </svg>
    );
};

export default React.memo(IconFooterTwitterInactive);
